<template>
  <div class="paper">
    <div v-if="!isRule" class="paper-main">
      <div class="contain">
        <div class="common">
          <!-- 搜索 -->
          <div class="top clearfix">
            <div class="fl">
              <span>搜索: </span>
              <el-input
                class="searchkey-input-com"
                placeholder="请输入"
                v-model="searchKey"
                size="small"
                @change="selectLsit(1)"
                clearable
              >
              </el-input>
              学年：
              <el-date-picker
                class="search-year"
                v-model="searchYear"
                value-format="yyyy"
                size="small"
                type="year"
                @change="selectLsit(1)"
              >
              </el-date-picker>
              学期：
              <el-select
                class="search-term"
                clearable
                v-model="searchTerm"
                size="small"
                @change="selectLsit(1)"
              >
                <template v-for="i of dic.schoolTerm">
                  <el-option :label="i.dicName" :value="i.dicCode"></el-option>
                </template>
              </el-select>
              <span class="check-status">状态：</span>
              <el-select
                :disabled="searchCheckStatusDisabled"
                clearable
                v-model="searchCheckStatus"
                class="open"
                size="small"
                @change="selectLsit(1)"
              >
                <template>
                  <el-option :key="0" label="待审核" :value="0"></el-option>
                  <el-option :key="1" label="通过" :value="1"></el-option>
                  <el-option :key="2" label="驳回" :value="2"></el-option>
                </template>
              </el-select>
              <br />
              <div style="margin: 10px 0">
                <span class="check-status">年级：</span>
                <el-select
                  clearable
                  v-model="searchgrade"
                  size="small"
                  @change="selectLsit(1)"
                >
                  <template v-for="i of classOptions">
                    <el-option
                      :key="i.id"
                      :label="i.gradeName"
                      :value="i.grade"
                    ></el-option>
                  </template>
                </el-select>
                <span class="check-status">学科：</span>
                <el-select
                  clearable
                  v-model="searchdisciplineCode"
                  size="small"
                  @change="selectLsit(1)"
                >
                  <template v-for="i of subjectOptions">
                    <el-option
                      :key="i.id"
                      :label="i.disciplineName"
                      :value="i.disciplineCode"
                    ></el-option>
                  </template>
                </el-select>
                <span class="check-status">公开教学等级：</span>
                <el-select
                  clearable
                  v-model="searchLevel"
                  size="small"
                  @change="selectLsit(1)"
                >
                  <template>
                    <el-option
                      v-for="item in ruleOptions"
                      :key="item.id"
                      :label="item.integralName"
                      :value="item.integralCode"
                    ></el-option>
                  </template>
                </el-select>
                <!-- <el-cascader 
              @change="getIntegralNum"
                   :props="defaultProps" v-model="searchLevel" :options="ruleOptions" size="small"></el-cascader> -->
              </div>
            </div>
            <div class="fr">
              <el-button
                size="small"
                @click="outCheck"
                v-if="isAdmin && !oneCheck"
                >取消</el-button
              >
              <el-button
                size="small"
                @click="goCheck"
                v-if="isAdmin && !oneCheck"
                >确定</el-button
              >
              <el-button size="small" @click="allCheck" v-if="isAdmin"
                >批量审核</el-button
              >
              <el-button
                size="small"
                icon="iconfont icon-daochu"
                @click="importTeacher"
                v-if="isAdmin"
                >导出</el-button
              >
              <el-button
                size="small"
                icon="iconfont icon-add"
                @click="showAddPop"
                >新增</el-button
              >
              <icon-integral-rule
                :isRule="isRule"
                @openRule="isRule = true"
              ></icon-integral-rule>
            </div>
          </div>
          <!-- 表格 -->
          <el-table
            element-loading-text="拼命加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.9)"
            v-loading="isTableLoading"
            row-key="id"
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="{ background: '#EFEFEF' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column v-if="showSelection" type="selection" width="55">
            </el-table-column>
            <el-table-column prop="schoolYear" label="学年" width="60">
            </el-table-column>
            <el-table-column prop="schoolTermDesc" label="学期" width="100">
            </el-table-column>
            <el-table-column prop="gradeName" label="年级"> </el-table-column>
            <el-table-column prop="disciplineName" label="学科">
            </el-table-column>
            <el-table-column prop="teacherName" label="开课教师">
            </el-table-column>
            <el-table-column prop="resType1Desc" label="公开教学等级">
            </el-table-column>
            <el-table-column prop="resName" label="公开教学名称">
            </el-table-column>
            <el-table-column label="附件" width="60">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="
                    showImg(
                      scope.row.resAttaches[0].url,
                      '研修成果-公开教学',
                      scope.row.resAttaches
                    )
                  "
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="score" label="获得积分">
              <template slot-scope="scope">
                {{ scope.row.checkStatus == "1" ? scope.row.score : "0" }}
              </template>
            </el-table-column>
            <el-table-column width="150" label="状态">
              <template slot-scope="scope">
                <!-- 驳回的 -->
                <el-popover
                  v-if="scope.row.checkStatus === '2'"
                  placement="top-start"
                  title="驳回原因："
                  trigger="hover"
                  :content="scope.row.checkDesc"
                >
                  <div
                    style="width: 50px"
                    slot="reference"
                    class="status"
                    :class="[
                      'status' + scope.row.checkStatus,
                      { pointer: isPointer(scope.row.checkStatus) },
                    ]"
                    @click="
                      showCheckEdit(
                        scope.$index,
                        scope.row,
                        scope.row.checkStatus
                      )
                    "
                  >
                    <span>·</span>
                    {{
                      scope.row.checkStatus === "1"
                        ? "通过"
                        : scope.row.checkStatus === "2"
                        ? "驳回"
                        : "待审核"
                    }}
                  </div>
                </el-popover>
                <!-- 未驳回的 -->
                <div v-else>
                  <div
                    class="status"
                    :class="[
                      'status' + scope.row.checkStatus,
                      { pointer: isPointer(scope.row.checkStatus) },
                    ]"
                    @click="
                      showCheckEdit(
                        scope.$index,
                        scope.row,
                        scope.row.checkStatus
                      )
                    "
                  >
                    <span>·</span>
                    {{
                      scope.row.checkStatus === "1"
                        ? "通过"
                        : scope.row.checkStatus === "2"
                        ? "驳回"
                        : "待审核"
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  :disabled="isDisabled(scope)"
                  type="text"
                  class="text-edit"
                  @click="showEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >|
                <el-button
                  :disabled="isDisabled(scope)"
                  type="text"
                  class="text-del"
                  @click="showDelPop(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <pagination
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          >
          </pagination>
          <!-- 删除的对话框 -->
          <popup-del
            :delVisible="delVisible"
            @close="closePopupDel"
          ></popup-del>

          <!--新增的对话框 -->
          <el-dialog
            class="add-pop"
            :visible.sync="addVisible"
            :close-on-click-modal="false"
            width="40%"
            top="5%"
          >
            <template v-slot:title>
              <div class="add-title">{{ form.id ? "编 辑" : "新 增" }}</div>
            </template>
            <!-- 对话框内容部分 => 匿名插槽 -->
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              label-width="120px"
            >
              <el-form-item label="学年" prop="schoolYear">
                <el-date-picker
                  class="width-form-input"
                  v-model="form.schoolYear"
                  value-format="yyyy"
                  type="year"
                  placeholder="请选择"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="学期" prop="schoolTerm">
                <el-select v-model="form.schoolTerm" placeholder="请选择">
                  <template v-for="i of dic.schoolTerm">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="年级" prop="grade">
                <el-select v-model="form.grade" placeholder="请选择">
                  <template v-for="i of classOptions">
                    <el-option
                      :key="i.id"
                      :label="i.gradeName"
                      :value="i.grade"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="学科" prop="disciplineCode">
                <el-select v-model="form.disciplineCode" placeholder="请选择">
                  <template v-for="i of subjectOptions">
                    <el-option
                      :key="i.id"
                      :label="i.disciplineName"
                      :value="i.disciplineCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <!-- 教师姓名 -->
              <el-form-item label="开课教师" prop="teacherId">
                <el-select
                  v-model="form.teacherId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入教师姓名关键字"
                  :remote-method="teacherKeyChange"
                  :loading="teacherLoading"
                >
                  <el-option
                    v-for="item in teacherOptions"
                    :key="item.id"
                    :label="
                      item.teacherNum
                        ? item.userName + '(师训号:' + item.teacherNum + ')'
                        : item.userName
                    "
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="公开教学等级" prop="ruleList">
                <el-cascader
                  @change="getIntegralNum"
                  class="width-form-input"
                  :props="defaultProps"
                  v-model="form.ruleList"
                  :options="ruleOptions"
                ></el-cascader>
              </el-form-item>
              <!-- 获奖类别 -->
              <el-form-item label="公开教学类别" prop="resClassify">
                <el-select
                  clearable
                  v-model="form.resClassify"
                  placeholder="请选择"
                >
                  <template v-for="i of typeOptions">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="公开教学名称" prop="resName">
                <el-input
                  placeholder="请输入"
                  v-model="form.resName"
                ></el-input>
              </el-form-item>
              <el-form-item label="上传附件" prop="resAttaches">
                <template>
                  <upload
                    :limit="10"
                    v-if="addVisible"
                    :allowType="1"
                    :fileLimit="50"
                    :fileList="form.resAttaches"
                    :fileUrl="form.resAttach"
                    @uploadFileUrl="uploadFileUrl"
                  ></upload>
                </template>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button @click="submitStudent" type="primary"
                  >提 交</el-button
                >
              </span>
            </template>
          </el-dialog>

          <!-- 审核框 -->
          <el-dialog
            class="add-pop"
            :visible.sync="checkVisible"
            :close-on-click-modal="false"
            width="40%"
            top="20%"
          >
            <template v-slot:title>
              <div class="add-title">审 核</div>
            </template>

            <el-form
              ref="checkForm"
              :model="checkForm"
              label-width="80px"
              :rules="checkRules"
            >
              <el-form-item prop="checkStatus" label="审核结果">
                <el-radio-group v-model="checkForm.checkStatus">
                  <el-radio border size="small" label="1">通过</el-radio>
                  <el-radio border size="small" label="2" class="radio-warning"
                    >驳回</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审核意见" prop="checkDesc">
                <el-input
                  type="textarea"
                  v-model="checkForm.checkDesc"
                ></el-input>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button @click="submitCheck" type="primary">提 交</el-button>
              </span>
            </template>
          </el-dialog>

          <!-- 图片预览弹框 -->
          <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
        </div>
      </div>
    </div>
    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";
import IconIntegralRule from "@/components/IconIntegralRule.vue";
import IntegralRuleView from "@/components/IntegralRuleView.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import { teacherKeyChange, exportExecl } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
import ViewImg from "@/components/ViewImg.vue";
export default {
  mixins: [mixin],
  components: {
    Breadcrumb,
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    Upload,
    Pagination,
    ViewImg,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
      "ruleOptions",
      "ruleOptionsList",
    ]),
  },
  created() {
    this.getDicClass();
    this.getDicSubject();
    this.getDicLevelAwards();
  },
  data() {
    return {
      classOptions: "",
      subjectOptions: "",
      typeOptions: [],
      imgVisible: false,
      imgUrl: "",
      searchKey: "",
      form: {
        disciplineCode: "",
        disciplineName: "",
        grade: "",
        gradeName: "",
        checkStatus: "0", //0：待审，1：通过，2：不通过
        resType: 3, //0：论文交流，1：课题研究，2：教学比武，3：公开教学，4、命题研究，5、作业设计，6、专题讲座，7、微视频
        resName: "",
        resDate: "",
        resAttach: "", //附件
        resAttaches: [], //附件
        resClassify: "",
      },
      checkForm: {
        checkStatus: "",
        checkDesc: "",
      },
      searchCheckStatus: "",
      searchgrade: "",
      searchdisciplineCode: "",
      searchLevel: "",
      showSelection: false,
      searchCheckStatusDisabled: false,
      allCheckIds: [],
      oneCheck: true, //单个审核
      checkRules: {
        checkStatus: [
          {
            required: true,
            message: "请选择审核结果",
            trigger: ["change", "blur"],
          },
        ],
      },
      rules: {
        resAttaches: [
          {
            required: true,
            message: "请上传附件",
            trigger: ["change", "blur"],
          },
        ],
        disciplineCode: [
          {
            required: true,
            message: "请选择学科",
            trigger: ["change", "blur"],
          },
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: ["change", "blur"],
          },
        ],
        resName: [
          {
            required: true,
            message: "请输入公开教学名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        ruleList: [
          {
            required: true,
            message: "请选择公开教学等级",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  methods: {
    // 获奖级别字典
    getDicLevelAwards() {
      const paramsDic = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        dicType: "openClassClassify",
        schoolCode: this.userInfo.schoolCode,
      };
      this.$axios
        .get("/dic/listDictionaryByDicType", { params: paramsDic })
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            this.typeOptions = res.data.records;
          }
        });
    },
    // 年级字典
    getDicClass() {
      const paramsDicClass = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        pageSize: 20,
      };
      this.$axios.post("/user/listGrade", paramsDicClass).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.classOptions = res.data.records;
        }
      });
    },
    //学科
    getDicSubject() {
      const paramsDicSubject = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        pageSize: 30,
      };
      this.$axios.post("/user/listDiscipline", paramsDicSubject).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.subjectOptions = res.data.records;
        }
      });
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        keyword: this.searchKey || "",
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        checkStatus: this.searchCheckStatus,
        grade: this.searchgrade || null,
        disciplineCode: this.searchdisciplineCode || null,
        resType1: this.searchLevel || null,
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/teacherResearch/getOpenClassList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "数据获取失败",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //导出
    importTeacher() {
      exportExecl(
        "/exp/expOpenClassInfo",
        "研修成果-公开教学-" + this.userInfo.userName,
        this.userInfo.schoolCode,
        this.pageObj.current,
        this.pageObj.size,
        this.searchYear,
        this.searchTerm,
        this.searchKey,
        this.searchCheckStatus,
        "",
        "",
        this.searchLevel,
        this.searchgrade,
        this.searchdisciplineCode
      );
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          let del = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            id: this.selectRow.id,
            operatorId: this.userInfo.userId,
          };
          let { resultCode, msg } = await this.$axios.post(
            "/teacherResearch/deleteTeacherResearchInfo",
            del
          );
          if (resultCode === 200) {
            this.selectLsit(this.pageObj.current, this.pageObj.size),
              this.$message.success("删除成功");
          } else {
            this.$message.error(msg);
          }
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //编辑
    showEdit(index, row) {
      this.selectRow = row;
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);
      this.form = {
        id: row.id,
        disciplineCode: row.disciplineCode,
        disciplineName: row.disciplineName,
        grade: row.grade,
        gradeName: row.gradeName,
        schoolYear: row.schoolYear + "",
        schoolTerm: row.schoolTerm + "",
        resType: row.resType,
        resName: row.resName,
        ruleList: [row.resType1],
        score: row.score,
        resDate: row.resDate,
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        resAttach: row.resAttach, //附件
        resAttaches: row.resAttaches, //附件
        resClassify: row.resClassify, //附件
      };
      this.isInclude(this.ruleOptionsList, this.form.ruleList)
        ? ""
        : (this.form.ruleList = []);
      this.getIntegralNum();
      this.addVisible = true;
    },
    // 新增
    showAddPop() {
      //清空form表单
      this.form = {
        id: "",
        schoolYear: "",
        schoolTerm: "",
        ruleList: "",
        score: "",
        teacherId: "",
        teacherName: "",
        resType: 3, //0：论文交流，1：课题研究，2：教学比武，3：公开教学，4、命题研究，5、作业设计，6、专题讲座，7、微视频
        resName: "",
        resDate: "",
        resAttach: "", //附件
        resAttaches: [], //附件

        disciplineCode: "",
        disciplineName: "",
        grade: "",
        gradeName: "",
        resClassify: "",
      };
      this.$refs.form && this.$refs.form.resetFields();
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            let subjectObj = this.subjectOptions.find(
              (item) => item.disciplineCode === this.form.disciplineCode
            );
            this.form.disciplineName = subjectObj.disciplineName;

            let classObj = this.classOptions.find(
              (item) => item.grade === this.form.grade
            );
            this.form.gradeName = classObj.gradeName;
            [this.form.resType1] = this.form.ruleList;
            this.$axios
              .post("/teacherResearch/updateTeacherResearchInfo", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            //保存
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            [this.form.resType1] = this.form.ruleList;
            let subjectObj = this.subjectOptions.find(
              (item) => item.disciplineCode === this.form.disciplineCode
            );
            this.form.disciplineName = subjectObj.disciplineName;

            let classObj = this.classOptions.find(
              (item) => item.grade === this.form.grade
            );
            this.form.gradeName = classObj.gradeName;
            this.$axios
              .post("/teacherResearch/saveTeacherResearchInfo", this.form)
              .then((res) => {
                console.log("re------s", res);
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "保存成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "error",
                    duration: 2000,
                    offset: 150,
                  });
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          }
        }
      });
    },
    //显示审核框
    showCheckEdit(index, row, status) {
      //教师不具有操作权限，，通过，，驳回，也不能操作
      if (!this.isAdmin || status == "1" || status == "2") {
        return;
      }

      this.selectRow = row;
      this.checkForm = {
        checkStatus: "",
        checkDesc: "",
      };
      this.$refs.checkForm && this.$refs.checkForm.resetFields();
      this.checkVisible = true;
      this.oneCheck = true;
    },
    //审核
    submitCheck() {
      this.$refs.checkForm.validate((valid) => {
        if (valid) {
          let checkPost = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            checkDesc: this.checkForm.checkDesc,
            checkStatus: this.checkForm.checkStatus,
            checkId: this.userInfo.userId,
            operatorId: this.userInfo.userId,
            checkName: this.userInfo.userName,
          };
          if (this.oneCheck) {
            //单个审核
            checkPost.id = this.selectRow.id;
          } else {
            //批量审核
            checkPost.ids = this.allCheckIds;
          }
          this.$axios
            .post("/teacherResearch/checkTeacherResearchInfo", checkPost)
            .then((res) => {
              if (res.resultCode == "200") {
                this.searchCheckStatus = "";
                this.searchCheckStatusDisabled = false;
                this.oneCheck = true;
                this.showSelection = false;
                this.selectLsit(this.pageObj.current, this.pageObj.size);
                this.$message.success("更改成功");
              } else {
                this.$message.error(res.msg);
              }
              this.checkVisible = false;
            })
            .catch((err) => {
              this.$message.error(res.msg);
            });
        }
      });
    },
    //批量审核 按钮
    allCheck() {
      this.oneCheck = false; //批量审核状态
      this.searchCheckStatus = 0; //状态
      this.searchCheckStatusDisabled = true; //状态不可选
      this.selectLsit(1);
      this.showSelection = true; //table 可选
    },
    handleSelectionChange(curRowList) {
      this.allCheckIds = curRowList.map((item) => item.id);
    },
    //取消审核 ，退出选中状态，退出审核
    outCheck() {
      this.searchCheckStatus = "";
      this.searchCheckStatusDisabled = false;
      this.oneCheck = true;
      this.selectLsit(1);
      this.showSelection = false;
      this.checkForm = {
        checkStatus: "",
        checkDesc: "",
      };
      this.$refs.checkForm && this.$refs.checkForm.resetFields();
      this.checkVisible = false;
    },
    //确定=》开始审核弹框
    goCheck() {
      if (this.allCheckIds.length === 0) {
        this.$message({
          message: "请先选择需要审核的内容！",
          type: "warning",
          duration: 4000,
          offset: 150,
        });
        return;
      }
      this.checkForm = {
        checkStatus: "",
        checkDesc: "",
      };
      this.$refs.checkForm && this.$refs.checkForm.resetFields();
      this.checkVisible = true;
    },
    //资源路径
    uploadFileUrl(fileUrl, fileList) {
      this.form.resAttaches = fileList;
      this.form.resAttach = fileUrl;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../styles/common.less";

.top {
  .fl {
    // width: calc(100% - 500px) !important;
    max-width: 712px !important;

    .check-status {
      margin-left: 2%;
    }

    .searchkey-input-com {
      width: 16% !important;
      margin-right: 2%;
    }

    .search-year {
      width: 16% !important;
    }

    .search-term {
      width: 16% !important;
    }

    .open {
      width: 12% !important;
    }
  }
}
</style>


